import { FormInput, Loader } from "@/components";
import { Button } from "@/components/ui";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { FormProvider } from "react-hook-form";
import useForgotPassword from "./useForgotPassword";
import logo from "@/assets/ostwal-logo.png";
import { EMAIL_ID } from "./consts";
import { CheckIcon } from "lucide-react";

const ForgotPassword = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    isForgotPasswordPending,
    showEmailMsg,
    onEmailSentOkClick,
  } = useForgotPassword();
  const { errors } = form.formState;

  return (
    <div className="w-full h-[100vh] bg-[url('/login-bg.png')] bg-no-repeat bg-cover">
      <div className="grid grid-cols-1 md:grid-cols-2 h-full p-[20px] md:p-[50px] lg:p-[80px]">
        <div className="flex items-center justify-center md:items-start md:justify-start">
          <img src={logo} className="w-[120px]" />
        </div>
        <div className="flex items-center justify-center md:justify-end">
          {showEmailMsg ? (
            <Card className="w-full lg:w-[400px]">
              <CardHeader className="my-[20px] flex flex-col items-center justify-center">
                <Button className="cursor-default h-[50px] w-[50px]">
                  <CheckIcon className="stroke-3" />
                </Button>
                <CardTitle className="text-center font-[500] text-[24px] ">
                  Email Sent Successfully
                </CardTitle>
                <span className="text-[14px] text-black font-[400]">
                  Login with temporary password
                </span>
              </CardHeader>
              <CardContent></CardContent>
              <CardFooter>
                <Button
                  type="button"
                  className="w-full"
                  disabled={isForgotPasswordPending}
                  onClick={onEmailSentOkClick}
                >
                  Ok
                </Button>
              </CardFooter>
            </Card>
          ) : (
            <FormProvider {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)}>
                <Card className="w-full lg:w-[400px]">
                  <CardHeader className="my-[20px]">
                    <CardTitle className="text-center font-[500] text-[24px] my-[40px]">
                      Forgot Password
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-col-1 gap-5">
                      <div>
                        <label className="text-[14px] font-[400]">Email</label>
                        <FormInput
                          name={EMAIL_ID}
                          control={form.control}
                          placeholder="Please enter"
                          error={errors[EMAIL_ID]?.message}
                          isRequired={requiredFields.includes(EMAIL_ID)}
                        />
                      </div>
                    </div>
                  </CardContent>
                  <CardFooter>
                    <Button
                      type="submit"
                      className="w-full"
                      disabled={isForgotPasswordPending}
                    >
                      {isForgotPasswordPending ? (
                        <Loader variant="secondary" />
                      ) : (
                        ""
                      )}{" "}
                      Send Email
                    </Button>
                  </CardFooter>
                </Card>
              </form>
            </FormProvider>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
